import { create } from 'zustand';
import AsyncStorage from '@react-native-async-storage/async-storage';

interface OnboardingStore {
  completed: boolean;
  selectedMoments: string[];
  currentStep: number;
  setCompleted: (completed: boolean) => void;
  toggleMoment: (momentId: string) => void;
  setCurrentStep: (step: number) => void;
  loadOnboarding: () => Promise<void>;
  saveOnboarding: () => Promise<void>;
}

const STORAGE_KEY = '@aia_onboarding';

export const useOnboardingStore = create<OnboardingStore>((set, get) => ({
  completed: false,
  selectedMoments: [],
  currentStep: 0,

  setCompleted: async (completed: boolean) => {
    set({ completed });
    await get().saveOnboarding();
  },

  toggleMoment: (momentId: string) => {
    set(state => ({
      selectedMoments: state.selectedMoments.includes(momentId)
        ? state.selectedMoments.filter(id => id !== momentId)
        : [...state.selectedMoments, momentId],
    }));
  },

  setCurrentStep: (step: number) => {
    set({ currentStep: step });
  },

  loadOnboarding: async () => {
    try {
      const stored = await AsyncStorage.getItem(STORAGE_KEY);
      if (stored) {
        const data = JSON.parse(stored);
        set(data);
      }
    } catch (error) {
      console.error('Failed to load onboarding:', error);
    }
  },

  saveOnboarding: async () => {
    try {
      const { completed, selectedMoments } = get();
      await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify({ completed, selectedMoments }));
    } catch (error) {
      console.error('Failed to save onboarding:', error);
    }
  },
}));
